import axios from 'axios'
import { ADMIN_TOKEN } from '@/utils/cache/cacheKey'
import { Message } from 'element-ui'
import { BASE_FILE_URL } from '@/config/env'

// 第一步,创建实例
const service = axios.create({
  // baseURL: '/devApi',
  baseURL: BASE_FILE_URL,
  timeout: 50000
})
// 第二步,请求拦截
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.token = localStorage.getItem(ADMIN_TOKEN)
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 第三步,响应拦截
service.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (response.status === 200) {
    if (response.data.code === 401) {
      localStorage.clear()
      Message.error('你还未登录,或登录已失效,请重新登录')
      location.href = '/login'
    }
    return response.data
  }
  return Message.error('服务器异常,请稍后再试!')
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default service
